import React from 'react';

const SVG = ({ style = {}, colors, width = '100%', viewBox = '0 0 400 400' }) => (
  <svg style={{ ...style, display: 'block' }} width={width} height={width} viewBox={viewBox} xmlns="http://www.w3.org/2000/svg">
    <g>
      <path d="M 198,0 L 0,210 279,225" fill={colors.light} />
      <path d="M 198,0 L 279,225 399,196" fill={colors.medium} />
      <path d="M 0,210 L 279,225 196,399" fill={colors.medium} />
      <path d="M 279,225 L 196,399 399,196" fill={colors.dark} />
    </g>
  </svg>
);

export default SVG;
